import React, { useEffect, useState } from "react";
import _ from "lodash";
import Socket from "socket";
import {
  divVariants,
  bounce_right_to_left_variants,staticBounceVariants
} from "shared/components/animations";
import { motion } from "framer-motion/dist/framer-motion";
import CHPTFlip from "assets/images/chpt/chpt-flip.png";
import { Button } from "reactstrap";

const ActivePlayerReading = ({
  prompt,
  played_cards,
  roomId,
  isReading = false,
  isEvaluating = false,
  onEvaluateCard = () => {},setWinnerSelectedCard=()=>{}
}) => {
  const [flippedArray, setFlippedArray] = useState([]);
  const allCardsFlipped = played_cards?.every((item) => item.flipped);
  useEffect(() => {
    const array = played_cards?.map((item) => ({
      cardId: item.card.id,
      flipped: false,
      opacityValue: 1
    }));
    setFlippedArray([...array]);
  }, []);

  const calculateOpacity = (id) => {
    setTimeout(() => {
      const array = flippedArray.map((item) =>
        item.cardId === id ? { ...item, opacityValue: 0 } : item
      );
      setFlippedArray([...array]);
    }, 800);
  };

  const handleFlipCard = (id) => {
    const array = flippedArray.map((item) =>
      item.cardId === id
        ? { ...item, flipped: true, opacityValue: calculateOpacity(id) }
        : item
    );
    setFlippedArray([...array]);
    const data = {
      action: "flip-card",
      roomId: roomId,
      cardId: id
    };
    console.log(data, "fgdgfdyfg");
    Socket.sendMessage(data);
  };

  useEffect(() => {
    if (isReading && allCardsFlipped) {
      updateRoomForEvaluation();
    }
  }, [isReading, allCardsFlipped]);
  const updateRoomForEvaluation = () => {
    const data = {
      action: "update-status",
      roomId: roomId
    };
    setTimeout(() => {
      console.log(data, "addddddd");
      Socket.sendMessage(data);
    }, 2000);
  };

  const handleWinner=(card)=>{
    setWinnerSelectedCard(card);
  }
  const opacityClass = (card) => {
    console.log(flippedArray,"jm");

  if (!_.isEmpty(flippedArray))
    return flippedArray.find((item) => item.cardId === card)?.opacityValue;
    else return 1; 
  };
  const isFlipped = (card) => {
 if (!_.isEmpty(flippedArray))
       return flippedArray.find((item) => item.cardId === card)?.flipped; 
  };
  return (
    <motion.div variants={divVariants}
    initial="hidden"
    animate="visible"
    exit="exit" className="chpt-reading-container">
      <motion.img variants={bounce_right_to_left_variants}  className="chart-img" src={prompt.url} alt="chartImg" />
      <motion.div variants={staticBounceVariants}  className="players-cards">
        {played_cards?.map((value, index) =>
          value.flipped ? (
            <div className="card" >
              <img
                src={value?.card?.url}
                alt="sliderContent"
                className="img-fluid"
              />
              <Button className="primary-solid" onClick={()=>handleWinner(value?.card)}>CHOOSE</Button>
            </div>
          ) : (
            <div className={`card${isFlipped(value.card.id) ? "" : ""} ${opacityClass(value.card.id) === 0 ? "card-flip-new" : ""} `}>
             <div className="blank-div"> </div>
              <img src={CHPTFlip} alt="sliderContent" className="img-fluid" />
              <Button className="primary-solid" onClick={() => handleFlipCard(value.card.id)} >FLIP</Button>
            </div>
          )
        )}
      </motion.div>
    </motion.div>
  );
};

export default ActivePlayerReading;
